export const UI_MODE_STORAGE_KEY = 'checkts-ui-mode';

export type UiMode = 'comfortable' | 'operational';

const VALID_MODES: readonly UiMode[] = ['comfortable', 'operational'];

export function isUiMode(value: string | null | undefined): value is UiMode {
  return value === 'comfortable' || value === 'operational';
}

/**
 * Admin always uses Comfortable presentation.
 * Legacy localStorage `operational` must not activate operational runtime.
 */
export function readStoredUiMode(): UiMode {
  return 'comfortable';
}

export function writeStoredUiMode(_mode: UiMode): void {
  /* Mode switch removed; storage writes are no-ops for runtime presentation. */
}

export function resolveUiMode(_value: string | null | undefined): UiMode {
  return 'comfortable';
}

export function applyUiModeToDocument(_mode?: UiMode): void {
  const root = document.documentElement;
  const body = document.body;
  root.classList.add('ui-mode-comfortable');
  root.classList.remove('ui-mode-operational');
  body.classList.add('ui-mode-comfortable');
  body.classList.remove('ui-mode-operational');
}

export function clearUiModeFromDocument(): void {
  for (const candidate of VALID_MODES) {
    document.documentElement.classList.remove(`ui-mode-${candidate}`);
    document.body.classList.remove(`ui-mode-${candidate}`);
  }
}
